import React from "react";
import { ReduxUpdater } from "../../../redux/ReduxUpdater";
import { useSelector } from "react-redux";
import { documentLoadingErrorState, documentLoadingState } from "../../../redux/slices/statusesSlice";
import ImageZoomPanFrame from "./Forms/ImageZoomPanFrame";
import { lastImageState } from "../../../redux/slices/tsSlice";
import { error } from "console";

interface ImageWithSpinnerProps {
  src: string;
  alt: string;
  rotation: number;
  className?: string;          // extra classes for <img>
  wrapperClassName?: string;   // extra classes for wrapper
}

export const ImageWithSpinner: React.FC<ImageWithSpinnerProps> = ({
  src,
  alt,
  rotation = 0,
  className = "",
  wrapperClassName = "",
}) => {
    const lastImageUpdatedTS = useSelector(lastImageState);
    const currentImageLoadingState = useSelector(documentLoadingState);
    const currentImageLoadingErrorState = useSelector(documentLoadingErrorState);

    const [errorCount, setErrorCount] = React.useState(0);

    return (
        <div
            className={`relative inline-block overflow-hidden ${wrapperClassName}`}
        >
            {/* Image (hidden until fully loaded) */}
            {!currentImageLoadingErrorState && (
                <ImageZoomPanFrame
                    alt={alt}
                    src={`${src}&ts=${lastImageUpdatedTS}`}
                    rotation={rotation}
                    onError={() => {
                        console.log('Image load error:', errorCount);
                        if (errorCount < 3) {
                            setErrorCount(prev => prev + 1);
                            ReduxUpdater.reloadImage();
                            return;
                        }
                        ReduxUpdater.documentLoadingError = true;
                    }}
                    onLoad={() => {
                        ReduxUpdater.documentLoading = false;
                        ReduxUpdater.documentLoadingError = false;
                        setErrorCount(0);
                    }}
                />
            )}

            {/* Spinner overlay while loading */}
            {currentImageLoadingState && !currentImageLoadingErrorState && (
                <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/70 backdrop-blur-sm">
                    {/* Preline/Tailwind spinner */}
                    <div
                        className="inline-flex h-10 w-10 rounded-full border-2 border-current border-r-transparent animate-spin
                                align-[-0.125em] text-blue-400"
                        role="status"
                        aria-label="Loading"
                    >
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            )}

            {/* Simple error state */}
            {currentImageLoadingErrorState && (
                <div className="flex h-full min-h-[120px] items-center justify-center bg-gray-100 text-sm text-gray-600">
                    <div className="columns-1 grid items-center justify-center">
                        <span className="block">Image failed to load!</span>
                        <button
                            className="w-[-webkit-fill-available] text-white h-10 px-3 bg-buttons-primary rounded-lg flex flex-1 justify-center items-center gap-2.5 disabled:opacity-50 disabled:pointer-events-none"
                            onClick={() => {
                                ReduxUpdater.documentLoading = true;
                                ReduxUpdater.documentLoadingError = false;
                                ReduxUpdater.reloadImage();
                            }}
                        >
                            Reload Image
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};
